import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/dashboard-shell";
import { YardsWorkspace } from "@/components/yards-workspace";
import { validateYardsSearch } from "@/lib/search";
import { Route as RootRoute } from "./__root";

export const Route = createFileRoute("/")({
  validateSearch: validateYardsSearch,
  component: HomePage,
});

function HomePage() {
  const { user } = RootRoute.useRouteContext();
  return (
    <DashboardShell userLabel={user?.displayName || user?.loginName || ""}>
      <YardsWorkspace />
    </DashboardShell>
  );
}
